import React, { useState } from "react";
import { Form } from "@themesberg/react-bootstrap";
import { getDateRangeByFilter } from "../../utils/helpers";

const filters = [
  { label: "Today", key: "today" },
  { label: "Yesterday", key: "yesterday" },
  { label: "This Week", key: "this_week" },
  { label: "This Month", key: "this_month" },
  { label: "Custom", key: "custom" },
  { label: "Lifetime", key: "lifetime" },
];

export default function DateFilterDropdown({setState , selectedFilter , setSelectedFilter, state}) {
//   const [selectedFilter, setSelectedFilter] = useState("yesterday");

const handleFilterChange = (e) => {
    const key = e.target.value;
    setSelectedFilter(key);

    const data  = getDateRangeByFilter(key, state);
    const {startDate,endDate} = data;   

    // Update only startDate and endDate inside the array
    setState((prev) => [
      {
        ...prev[0],
        startDate,
        endDate,
      },
    ]);
  };


  return (
    <div className="d-flex align-items-center gap-2">
      <Form.Select
        value={selectedFilter}
        onChange={handleFilterChange}
        size="sm"
        // style={{ width: "auto" }}
      >
        {filters.map(({ label, key }) => (
          <option key={key} value={key}>{label}</option>
        ))}
      </Form.Select>


    </div>
  );
}
